import type { Context } from 'react';
import { createContext, useContext } from 'react';

import { Nullable } from '..';

/**
 *
 * @param displayName - to report an error if context isn't provided;
 */
export const createNullableContext = <T>(displayName: string) => {
  const context = createContext<Nullable<T>>(null);

  context.displayName = displayName;

  return context;
};

export const useNullableContext = <T>(context: Context<T>) => {
  const contextValue = useContext(context);

  if (!contextValue) {
    throw new Error(`${context.displayName} is not provided`);
  }

  return contextValue;
};
